module.exports = __webpack_public_path__ + "static/media/15695220565621752122636.e7c5f38b.jpg";